import {Type} from 'main.core';
import './main.css';

// Загрузка объекта для работы на странице корзины
import {Cart} from "./cart.js";

// Загрузка объекта для работы на странице ЛК и в других местах,
// где требуется получить или отправить данные пользователя
import {Personal} from "./personal.js";

import {ModalSMSAuth} from "./modalSmsAuth.js";
import {Register} from "./register.js";

export class Mindbox
{
    constructor(options = {name: 'Mindbox'})
    {
        this.name = options.name;
        this.cart = Cart;
        this.personal = Personal;
        this.modalSmsAuth = ModalSMSAuth;
        this.register = Register;
    }

    setName(name)
    {
        if (Type.isString(name)) {
            this.name = name;
        }
    }

    getName()
    {
        return this.name;
    }

    /**
     * Метод удаляет все элементы внутри заданного элемента DOM
     *
     * @param elem
     */
    clearElem(elem)
    {
        while (elem.firstChild) {
            elem.firstChild.remove()
        }
    }

    /**
     * Функция добавляет лоадер (анимацию процесса работы) в кнопку
     *
     * @param elem
     */
    addLoadingToBtn(elem)
    {
        if (!window.obMindbox.isHasClass(elem, "loading")) {
            // Убедились, что сейчас нет класса работающей анимации
            elem.insertAdjacentHTML(
                "afterBegin",
                '<svg width="27" height="27" viewBox="0 0 27 27"><defs><style>.load{fill:#4f95e8;}</style></defs><path class="load" d="M27,22.254a14.723,14.723,0,0,0-1.159-5.468,14.263,14.263,0,0,0-3.076-4.553,13.642,13.642,0,0,0-4.49-2.971A13.134,13.134,0,0,0,7.94,9.47a13.365,13.365,0,0,0-4.265,3.081A13.755,13.755,0,0,0,.894,17.045a13.95,13.95,0,0,0,.2,10.333,13.364,13.364,0,0,0,2.888,4.261,12.769,12.769,0,0,0,4.208,2.776,12.289,12.289,0,0,0,9.667-.208,12.493,12.493,0,0,0,3.983-2.886,12.865,12.865,0,0,0,3.315-7.12c.034,0,.068,0,.1,0A1.771,1.771,0,0,0,27,22.4c0-.051,0-.1-.006-.15Zm-2.768,4.779a12.462,12.462,0,0,1-2.7,3.97,11.9,11.9,0,0,1-3.926,2.581,11.444,11.444,0,0,1-9-.208,11.627,11.627,0,0,1-3.7-2.691,11.948,11.948,0,0,1-2.4-3.91,12.078,12.078,0,0,1-.758-4.52A11.938,11.938,0,0,1,2.7,17.82a11.56,11.56,0,0,1,2.51-3.678,11.029,11.029,0,0,1,3.643-2.386,10.6,10.6,0,0,1,8.333.208,10.755,10.755,0,0,1,3.419,2.5,11.072,11.072,0,0,1,2.907,7.794h.007c0,.049-.007.1-.007.15a1.779,1.779,0,0,0,1.554,1.789A12.715,12.715,0,0,1,24.232,27.033Z" transform="translate(0 -8.304)"></path></svg>'
            );

            // Запуск анимации вращения
            elem.classList.add("loading");
        }
    }

    /**
     * Функция удаляет лоадер (анимацию процесса работы) из кнопки
     *
     * @param elem
     */
    removeLoadingFromBtn(elem)
    {
        for (let i = 0; i < elem.childNodes.length; i++) {
            let tagName = elem.childNodes[i].tagName;
            if ("SVG" === tagName.toUpperCase()) {
                elem.childNodes[i].remove();
                elem.classList.remove("loading");
                break;
            }
        }
    }

    /**
     * Функция проверяет наличие класса у элемента DOM
     *
     * @param elem
     * @param className
     *
     * @returns {boolean}
     */
    isHasClass(elem, className)
    {
        let result = true;
        if ((" " + elem.className + " ").replace(/[\n\t]/g, " ").indexOf(" " + className + " ") === -1) {
            result = false;
        }

        return result;
    }

    /**
     * Find first ancestor of el with tagName
     * or undefined if not found
     */
    upTo(el, tagName)
    {
        "use strict";

        tagName = tagName.toLowerCase();

        while (el && el.parentNode) {
            el = el.parentNode;
            if (el.tagName && el.tagName.toLowerCase() === tagName) {
                return el;
            }
        }

        // Many DOM methods return null if they don't
        // find the element they are searching for
        // It would be OK to omit the following and just
        // return undefined
        return null;
    }
    getPreviousSibling(el, tagClass)
    {
        "use strict";

        let prevSibling = el.previousElementSibling;
        while (prevSibling) {
            if (window.obMindbox.isHasClass(prevSibling, tagClass)) {
                return prevSibling;
            }
            prevSibling = el.previousElementSibling;
        }

        return null;
    }
}
